var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.0718 61.7668C28.2137 62.9294 18.0692 59.6963 9.56458 53.1622C4.98798 49.6491 2.2607 44.965 1.38277 39.1098C0.266935 31.7102 1.42808 25.1224 4.86619 19.3464C10.9438 9.1295 19.8223 2.77082 31.5017 0.270347C33.0933 -0.0690844 34.7331 -0.0888908 36.421 0.21094C46.4549 1.99295 53.8636 6.90623 58.2731 15.8587C62.4023 24.2342 63.3963 33.611 59.4711 42.1901C57.4745 46.5518 54.6198 51.1256 51.7056 54.9951C48.647 59.0429 44.144 61.2237 39.0718 61.7668Z",
    fill: "#F3E2C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0409 17L27.9982 32.6533L16.9727 45.3805H19.4548L29.1086 34.2382L36.908 45.3805H45.3532L33.7799 28.8467L44.043 17H41.5609L32.6712 27.2618L25.4878 17H17.0426H17.0409ZM20.69 18.9531H24.5689L41.7008 43.4274H37.8219L20.69 18.9531Z",
    fill: "#4B2C5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.67f738d887ad80d2f0378db8166645da.svg";
export { ForwardRef as ReactComponent };